import { computed, nextTick, WritableComputedRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export function useRouteHash(): WritableComputedRef<string> {
  const route = useRoute();
  const router = useRouter();

  return computed({
    get() {
      return route.hash.replace('#', '') ?? '';
    },
    set(hash) {
      nextTick(() => {
        router.replace({ hash: `#${hash}` });
      });
    },
  });
}
